import { render, staticRenderFns } from "./payrollLogDetails.vue?vue&type=template&id=3a28e66b&scoped=true&"
import script from "./payrollLogDetails.vue?vue&type=script&lang=js&"
export * from "./payrollLogDetails.vue?vue&type=script&lang=js&"
import style0 from "./payrollLogDetails.vue?vue&type=style&index=0&id=3a28e66b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a28e66b",
  null
  
)

export default component.exports